// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class ROC extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Rate of Change';
        this.Comments = 'Shows the speed at which price is changing';
        this.SetIndicatorLine('ROC', Color.Brown, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.SetLevelLine('Zero', 0, Color.Gray, 1, LineStyle.ShapedChart);
        this.MAPeriod = 20;
        super.InputParameter(new InputParameterInteger('MAPeriod', 'Period of MA for envelopese', 1, 1, 99999));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'ROC(' + this.MAPeriod + ')';
    }
    getCustomName() {
        return 'ROC (' + this.ProjectName + ')';
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count <= this.MAPeriod) {
            return;
        }
        const price = this.CurrentData.getPriceByType(PriceType.Close, 0);
        const pricen = this.CurrentData.getPriceByType(PriceType.Close, this.MAPeriod);
        this.SetValue(0, 0, (100 * (price - pricen)) / pricen);
    }
}
